(function () {
  'use strict';

  /* @ngdoc object
   * @name statements
   * @description
   *
   */
  angular
    .module('statements', [
      'ui.router'
    ]);
}());
